import React, { useMemo, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "./WaveSaleslandingpage/img/logo.png";
import api from "../api";

const COUNTRIES = [
  { code: "+593", name: "Ecuador" },
  { code: "+57", name: "Colombia" },
  { code: "+51", name: "Perú" },
  { code: "+52", name: "México" },
  { code: "+56", name: "Chile" },
  { code: "+54", name: "Argentina" },
  { code: "+1", name: "Estados Unidos" },
  { code: "+34", name: "España" },
];

const INDUSTRIES = [
  "Tecnología",
  "Educación",
  "Salud",
  "Retail / Comercio",
  "Inmobiliario",
  "Finanzas",
  "Turismo",
  "Otro",
];

const ROLES_BASE = [
  "CEO / Fundador",
  "Gerente Comercial",
  "Marketing",
  "Atención al Cliente",
  "Ventas",
  "Operaciones",
  "Otro",
];

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export default function DemoWizard() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1); // 1..9
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [countryCode, setCountryCode] = useState("+593");
  const [phone, setPhone] = useState("");
  const [country2, setCountry2] = useState("Ecuador");
  const [industry, setIndustry] = useState("");
  const [industryOther, setIndustryOther] = useState("");
  const [adSpend, setAdSpend] = useState("");
  const [teamSize, setTeamSize] = useState("");
  const [role, setRole] = useState("");
  const [roles, setRoles] = useState(ROLES_BASE);
  // Agendamiento (paso 7)
  const [selectedDayIdx, setSelectedDayIdx] = useState(null); // 0 o 1
  const [selectedTime, setSelectedTime] = useState(""); // "12:00" | "14:00"
  const twoNextDays = useMemo(() => {
    const start = new Date();
    const d1 = new Date(start);
    d1.setDate(start.getDate() + 1);
    d1.setHours(0,0,0,0);
    const d2 = new Date(start);
    d2.setDate(start.getDate() + 2);
    d2.setHours(0,0,0,0);
    return [d1, d2];
  }, []);
  const [done, setDone] = useState(false);
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);
  const lastFocusRef = useRef(null);
  const isTypingRef = useRef(false);
  const focusGuardTimerRef = useRef(null);

  // Utilidad para mantener el foco y la posición del cursor tras onChange
  const keepFocus = (ref) => {
    const el = ref?.current;
    if (!el) return;
    const len = typeof el.value === 'string' ? el.value.length : 0;
    // Forzamos el foco y el cursor al final sin provocar scroll
    requestAnimationFrame(() => {
      try {
        if (document.activeElement !== el) el.focus({ preventScroll: true });
        if (typeof el.setSelectionRange === 'function') el.setSelectionRange(len, len);
      } catch {}
    });
  };

  useEffect(() => {
    if (step === 6) {
      setRoles(shuffle(ROLES_BASE));
    }
  }, [step]);

  // Guardia global: recuerda el último campo con foco y, si durante la escritura
  // el foco cae en el <body>, lo restaura (cubre todos los pasos/navegadores).
  useEffect(() => {
    const isTextField = (el) => !!el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable);
    const typingRef = { current: false };
    const onFocusIn = (e) => {
      const t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA')) {
        lastFocusRef.current = t;
      }
    };
    const onInput = () => {
      typingRef.current = true;
      setTimeout(() => (typingRef.current = false), 120);
      requestAnimationFrame(() => {
        const active = document.activeElement;
        if (typingRef.current && (!isTextField(active) || active === document.body) && lastFocusRef.current) {
          try {
            const el = lastFocusRef.current;
            el.focus({ preventScroll: true });
            if (typeof el.setSelectionRange === 'function') {
              const len = typeof el.value === 'string' ? el.value.length : 0;
              el.setSelectionRange(len, len);
            }
          } catch {}
        }
      });
    };
    document.addEventListener('focusin', onFocusIn, true);
    document.addEventListener('input', onInput, true);
    return () => {
      document.removeEventListener('focusin', onFocusIn, true);
      document.removeEventListener('input', onInput, true);
    };
  }, []);

  // Focus lock con temporizador mientras se escribe en el paso 1
  useEffect(() => {
    if (step !== 1) {
      if (focusGuardTimerRef.current) {
        clearInterval(focusGuardTimerRef.current);
        focusGuardTimerRef.current = null;
      }
      return;
    }
    if (focusGuardTimerRef.current) clearInterval(focusGuardTimerRef.current);
    focusGuardTimerRef.current = setInterval(() => {
      if (!isTypingRef.current) return;
      const el = lastFocusRef.current;
      if (!el) return;
      const active = document.activeElement;
      const isInput = active && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA');
      if (!isInput) {
        try {
          el.focus({ preventScroll: true });
          if (typeof el.setSelectionRange === 'function') {
            const len = typeof el.value === 'string' ? el.value.length : 0;
            el.setSelectionRange(len, len);
          }
        } catch {}
      }
    }, 60);
    return () => {
      if (focusGuardTimerRef.current) {
        clearInterval(focusGuardTimerRef.current);
        focusGuardTimerRef.current = null;
      }
    };
            {country2 !== 'Ecuador' && selectedDayIdx !== null && selectedTime && (
              (() => {
                try {
                  const [hh, mm] = String(selectedTime).split(':');
                  const baseDay = twoNextDays[selectedDayIdx];
                  const baseDate = buildZonedDate(baseDay.getFullYear(), baseDay.getMonth()+1, baseDay.getDate(), parseInt(hh||'12',10), parseInt(mm||'0',10), 'America/Guayaquil');
                  const meta = COUNTRY_META[country2] || COUNTRY_META['Ecuador'];
                  const alt = formatInZone(baseDate, meta.tz, false, false);
                  return <div className="text-xs text-gray-500 mt-2">En {country2}: {alt}</div>;
                } catch {
                  return null;
                }
              })()
            )}
  }, [step]);

  useEffect(() => {
    if (step === 1) {
      // Mantener foco en el campo activo del paso 1
      const active = document.activeElement;
      if (active === emailRef.current || active === phoneRef.current) return;
      try { nameRef.current && nameRef.current.focus(); } catch {}
    }
  }, [step]);

  const validEmail = useMemo(() => /.+@.+\..+/.test(email), [email]);
  // Teléfono local: 9 dígitos, sin 0 inicial
  const validPhone = useMemo(() => /^\d{9}$/.test(phone), [phone]);
  const canNext = useMemo(() => {
    if (step === 1) return name.trim().length > 1 && validEmail && validPhone;
    if (step === 2) return Boolean(country2);
    if (step === 3) return Boolean(industry) && (industry !== "Otro" || industryOther.trim().length > 1);
    if (step === 4) return Boolean(adSpend);
    if (step === 5) return Boolean(teamSize);
    if (step === 6) return Boolean(role);
    if (step === 7) return selectedDayIdx !== null && Boolean(selectedTime);
    if (step === 8) return true; // Confirmación/resumen siempre permite avanzar
    return true;
  }, [step, name, validEmail, validPhone, country2, industry, industryOther, adSpend, teamSize, role, selectedDayIdx, selectedTime]);

  const progressPct = useMemo(() => {
    // Progreso visible desde el paso 3. Mantener 4 peldaños de 25%: 3-4:25%, 5-6:50%, 7-8:75%, 9:100%
    if (step < 3) return 0;
    if (step <= 4) return 25;
    if (step <= 6) return 50;
    if (step <= 8) return 75;
    return 100;
  }, [step]);

  // Header y layout se renderizan inline para evitar remounts que rompan el foco

  // Utilidades reCAPTCHA (opcional)
  const recaptchaSiteKey = (import.meta && import.meta.env && import.meta.env.VITE_RECAPTCHA_SITE_KEY) || "";
  const ensureRecaptcha = () => new Promise((resolve) => {
    try {
      const host = (typeof window !== 'undefined' && window.location && window.location.hostname) ? window.location.hostname : '';
      const isIP = /^\d{1,3}(?:\.\d{1,3}){3}$/.test(host);
      if (!recaptchaSiteKey || isIP) return resolve();
      if (window.grecaptcha && window.grecaptcha.execute) return resolve();
      const existing = document.querySelector('script[data-rec="v3"]');
      if (existing) { existing.addEventListener('load', () => resolve()); return; }
      const s = document.createElement('script');
      s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(recaptchaSiteKey)}`;
      s.async = true; s.defer = true; s.dataset.rec = 'v3';
      s.onload = () => resolve(); s.onerror = () => resolve();
      document.head.appendChild(s);
    } catch { resolve(); }
  });
  const getRecaptchaToken = async (action = 'wizard_demo_confirm') => {
    await ensureRecaptcha();
    try {
      if (!window.grecaptcha || !recaptchaSiteKey) return '';
      return await window.grecaptcha.execute(recaptchaSiteKey, { action });
    } catch { return ''; }
  };

  const [sendingWA, setSendingWA] = useState(false);

  // Mapear país a zona horaria IANA (aprox)
  const COUNTRY_TZ = {
    'Ecuador': 'America/Guayaquil',
    'Colombia': 'America/Bogota',
    'Perú': 'America/Lima',
    'México': 'America/Mexico_City',
    'Chile': 'America/Santiago',
    'Argentina': 'America/Argentina/Buenos_Aires',
    'Estados Unidos': 'America/New_York',
    'España': 'Europe/Madrid',
  };
  const COUNTRY_META = {
    'Ecuador': { tz: 'America/Guayaquil', flag: '\uD83C\uDDEA\uD83C\uDDE8', label: 'Ecuador - Quito' },
    'Colombia': { tz: 'America/Bogota', flag: '🇨🇴', label: 'Colombia' },
    'Perú': { tz: 'America/Lima', flag: '🇵🇪', label: 'Perú' },
    'México': { tz: 'America/Mexico_City', flag: '🇲🇽', label: 'Cd de México' },
    'Chile': { tz: 'America/Santiago', flag: '🇨🇱', label: 'Chile' },
    'Argentina': { tz: 'America/Argentina/Buenos_Aires', flag: '🇦🇷', label: 'Buenos Aires' },
    'Estados Unidos': { tz: 'America/New_York', flag: '🇺🇸', label: 'Estados Unidos (Este)' },
    'España': { tz: 'Europe/Madrid', flag: '🇪🇸', label: 'España' },
  };
  const EC_FLAG = COUNTRY_META['Ecuador'].flag;

  // Construir un Date (UTC) que, al formatearse en timeZone, rinda los componentes deseados (y,m,d,h,min)
  const buildZonedDate = (y, m, d, h, min, timeZone) => {
    try {
      let utc = Date.UTC(y, m - 1, d, h, min, 0);
      let date = new Date(utc);
      const fmt = new Intl.DateTimeFormat('es-ES', {
        timeZone,
        hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
      });
      const toParts = (dt) => {
        const parts = fmt.formatToParts(dt);
        const get = (t) => Number((parts.find(p => p.type === t) || {}).value);
        return { y: get('year'), m: get('month'), d: get('day'), h: get('hour'), min: get('minute') };
      };
      for (let i = 0; i < 3; i++) {
        const got = toParts(date);
        const desiredUTC = Date.UTC(y, m - 1, d, h, min);
        const gotUTC = Date.UTC(got.y, got.m - 1, got.d, got.h, got.min);
        const delta = desiredUTC - gotUTC;
        if (delta === 0) break;
        utc += delta; date = new Date(utc);
      }
      return date;
    } catch {
      // Fallback: interpretar en la TZ local del navegador
      return new Date(y, m - 1, d, h, min, 0);
    }
  };

  const formatInZone = (date, timeZone, withDate = false, hour12 = true) => {
    try {
      const opts = withDate
        ? { timeZone, weekday: 'long', day: '2-digit', month: 'long' }
        : { timeZone, hour: 'numeric', minute: '2-digit', hour12 };
      return new Intl.DateTimeFormat('es-ES', opts).format(date);
    } catch {
      return new Intl.DateTimeFormat('es-ES', withDate ? { weekday: 'long', day: '2-digit', month: 'long' } : { hour: 'numeric', minute: '2-digit', hour12 }).format(date);
    }
  };

  const handleFinalize = async () => {
    // Preparar y enviar mensaje por WhatsApp vía backend público
    const cc = String(countryCode || '').replace(/\D/g, '');
    const local = String(phone || '').replace(/\D/g, '');
    const toDigits = cc + local;
    // Interpretar la hora elegida en base a Ecuador (slots definidos en horario de Ecuador)
    const baseTz = 'America/Guayaquil';
    const baseDay = twoNextDays[selectedDayIdx || 0];
    const [hhStr, mmStr] = String(selectedTime || '12:00').split(':');
    const y = baseDay.getFullYear();
    const m = baseDay.getMonth() + 1;
    const d = baseDay.getDate();
    const h = parseInt(hhStr || '12', 10);
    const mm = parseInt(mmStr || '0', 10);
    const baseDate = buildZonedDate(y, m, d, h, mm, baseTz);
    // Fechas formateadas
    const dayStr = formatInZone(baseDate, baseTz, true, false);
    const hourEC = formatInZone(baseDate, 'America/Guayaquil', false, false);
    const selMeta = COUNTRY_META[country2] || COUNTRY_META['Ecuador'];
    const hourSel = formatInZone(baseDate, selMeta.tz, false, false);
    // Link para agregar a Google Calendar (30 min)
    const endDate = new Date(baseDate.getTime() + 30 * 60000);
    const iso = (d) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
    const gcal = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent('Demo con ' + (name || 'WaveSales'))}&dates=${iso(baseDate)}/${iso(endDate)}&details=${encodeURIComponent('Demo de WaveSales (online)')}`;
    // Mensaje con emojis y formato solicitado
    const lines = [];
    lines.push(`Tu demo fue agendada para ${dayStr} ⏰ Hora de la sesión:`);
    if (country2 === 'Ecuador') {
      lines.push(`  ${EC_FLAG} - ${hourEC} Ecuador - Quito`);
    } else {
      lines.push(`  ${EC_FLAG} - ${hourEC} Ecuador - Quito`);
      lines.push(`  ${selMeta.flag} - ${hourSel} Horario ${selMeta.label}`);
    }
    lines.push('');
    lines.push('Haz clic aquí abajo para agregar la sesión a tu calendario y asegura tu lugar.');
    lines.push(gcal);
    const msg = lines.join('\n');
    // Email (mismo contenido + saludo)
    const emailSubject = `Demo con ${name || 'WaveSales'}`;
    const emailBody = [`Hola${name ? `, ${name}` : ''}! Somos WaveSales.`, '', ...lines].join('\n');
    setSendingWA(true);
    try {
      const token = await getRecaptchaToken();
      const payload = {
        name,
        email,
        phone: `${countryCode} ${phone}`,
        toPhone: toDigits,
        message: msg,
        recaptcha: token,
      };
      const { data } = await api.post('public/lead-message/', payload);
      // Enviar correo inmediato
      if (email) {
        try {
          await api.post('public/demo-email/', { to: email, subject: emailSubject, body: emailBody });
        } catch (_) { /* no bloquear */ }
      }
      // Programar recordatorio T-15 (WhatsApp + email)
      try {
        const remindAt = baseDate.getTime() - 15 * 60 * 1000;
        if (remindAt > Date.now()) {
          const reminderLines = [];
          reminderLines.push(`Ya solo faltan 15 minutos para comenzar la reunión.`);
          reminderLines.push('');
          reminderLines.push(`⏰ Hora de la sesión:`);
          if (country2 === 'Ecuador') {
            reminderLines.push(`  ${EC_FLAG} - ${hourEC} Ecuador - Quito`);
          } else {
            reminderLines.push(`  ${EC_FLAG} - ${hourEC} Ecuador - Quito`);
            reminderLines.push(`  ${selMeta.flag} - ${hourSel} Horario ${selMeta.label}`);
          }
          const reminderMsg = reminderLines.join('\n');
          const publicClientId = (import.meta && import.meta.env && import.meta.env.VITE_WHATSAPP_PUBLIC_CLIENT_ID) || 'server-check';
          const host = (typeof window !== 'undefined' && window.location && window.location.hostname) ? window.location.hostname : '127.0.0.1';
          const svcUrl = `http://${host}:3001/schedule/send`;
          // Construir URL absoluta del backend para callback de email
          let apiBaseAbs = '';
          try {
            const v = import.meta && import.meta.env && import.meta.env.VITE_API_URL;
            if (v && /^https?:\/\//i.test(String(v))) {
              let raw = String(v).trim().replace(/\s+/g, '').replace(/\/+$/, '');
              apiBaseAbs = /\/api$/i.test(raw) ? raw + '/' : raw + '/api/';
            } else if (typeof window !== 'undefined' && window.location && window.location.origin) {
              apiBaseAbs = window.location.origin.replace(/\/$/, '') + '/api/';
            }
          } catch {}
          const emailCallbackUrl = apiBaseAbs ? (apiBaseAbs + 'public/demo-email/') : '';
          const callback = (email && emailCallbackUrl) ? {
            url: emailCallbackUrl,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: { to: email, subject: `${emailSubject} — recordatorio 15 minutos`, body: [`Hola${name ? `, ${name}` : ''}!`, '', ...reminderLines].join('\n') },
          } : null;
          try {
            await fetch(svcUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ clientId: publicClientId, number: toDigits, message: reminderMsg, at: remindAt, callback }),
            });
          } catch (_) { /* no bloquear */ }
        }
      } catch (_) { /* no bloquear */ }
      // Si el servicio aún no está listo, el backend devolverá 409 con client_not_ready
      // En éxito o en fallo no bloqueante, finalizamos el wizard y mostramos pantalla done
      setDone(true);
    } catch (e) {
      try {
        const status = e?.response?.status;
        const data = e?.response?.data;
        let txt = 'No se pudo enviar el WhatsApp automático. ';
        if (status) txt += `(HTTP ${status}) `;
        if (data?.detail) txt += data.detail;
        if (data?.error === 'client_not_ready' || /client_not_ready/i.test(String(data?.error||''))) {
          txt += '\nAbre el QR y autentica la sesión pública: http://localhost:3001/qr-view?clientId=server-check';
        }
        alert(txt + '\nTu demo quedó registrada de todas formas.');
      } catch {
        alert('No se pudo enviar el WhatsApp automático. Tu demo quedó registrada de todas formas.');
      } finally {
        setDone(true);
      }
    } finally {
      setSendingWA(false);
    }
  };

  if (done) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
        <header className="flex items-center justify-between p-4 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center gap-3">
            <img src={logo} alt="WaveSales" style={{ height: 36 }} />
            <div className="text-sm text-gray-600 dark:text-gray-300">Te ayudamos a interactuar con tus clientes facilmente</div>
          </div>
          <Link to="/" className="text-indigo-600 hover:underline">Volver al inicio</Link>
        </header>
        <main className="max-w-2xl mx-auto p-6">
          <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 shadow p-6">
            <h1 className="text-2xl font-semibold mb-2">¡Listo! 🎉</h1>
            <p className="text-gray-600 dark:text-gray-300">Gracias {name}. Hemos recibido tu solicitud para agendar una demo. Te contactaremos al {countryCode} {phone} o a {email}.</p>
            <p className="mt-3 text-sm text-gray-500">Mientras tanto, si tienes dudas, escríbenos en el chat de WaveSales.</p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <header className="flex items-center justify-between p-4 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center gap-3">
          <img src={logo} alt="WaveSales" style={{ height: 36 }} />
          <div className="text-sm text-gray-600 dark:text-gray-300">Te ayudamos a interactuar con tus clientes facilmente</div>
        </div>
        <Link to="/" className="text-indigo-600 hover:underline">Volver al inicio</Link>
      </header>
      {step >= 3 && (
        <div className="w-full px-4 pt-3">
          <div className="text-sm text-gray-600 dark:text-gray-300 mb-1">{progressPct}%</div>
          <div className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded">
            <div className="h-2 bg-indigo-600 rounded" style={{ width: `${progressPct}%`, transition: "width .3s" }} />
          </div>
        </div>
      )}
      <main className="max-w-2xl mx-auto p-6">
        <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 shadow p-6">
      {step === 1 && (
        <form onSubmit={(e)=>e.preventDefault()} noValidate>
          <h1 className="text-xl font-semibold mb-1">Agendar demo — Datos básicos</h1>
          <p className="text-gray-600 dark:text-gray-300 mb-4">Cuéntanos de ti. Estos campos son obligatorios.</p>
          <div className="grid grid-cols-1 gap-4">
            <label className="flex flex-col gap-1">
              <span className="text-sm text-gray-600 dark:text-gray-400">Nombre completo</span>
              <input
                ref={nameRef}
                type="text"
                value={name}
                onInput={()=>{ isTypingRef.current = true; setTimeout(()=>isTypingRef.current=false, 120); }}
                onChange={e=>{ setName(e.target.value); keepFocus(nameRef); }}
                onKeyDown={(e)=>{ if(e.key==='Enter'){ e.preventDefault(); } }}
                onFocus={()=>{ lastFocusRef.current = nameRef.current; }}
                onBlur={(e)=>{
                  const next = e.relatedTarget;
                  const isAllowedNext = next && (next.tagName === 'INPUT' || next.tagName === 'BUTTON' || next.tagName === 'SELECT' || next.getAttribute('role') === 'button');
                  if (!isAllowedNext && isTypingRef.current) {
                    keepFocus(nameRef);
                  }
                }}
                className="px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900"
                placeholder="Tu nombre"
                autoComplete="name"
              />
            </label>
            <label className="flex flex-col gap-1">
              <span className="text-sm text-gray-600 dark:text-gray-400">Correo electrónico</span>
              <input
                ref={emailRef}
                type="email"
                value={email}
                onInput={()=>{ isTypingRef.current = true; setTimeout(()=>isTypingRef.current=false, 120); }}
                onChange={e=>{ setEmail(e.target.value); keepFocus(emailRef); }}
                onKeyDown={(e)=>{ if(e.key==='Enter'){ e.preventDefault(); } }}
                onFocus={()=>{ lastFocusRef.current = emailRef.current; }}
                onBlur={(e)=>{
                  const next = e.relatedTarget;
                  const isAllowedNext = next && (next.tagName === 'INPUT' || next.tagName === 'BUTTON' || next.tagName === 'SELECT' || next.getAttribute('role') === 'button');
                  if (!isAllowedNext && isTypingRef.current) {
                    keepFocus(emailRef);
                  }
                }}
                className="px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900"
                placeholder="tucorreo@ejemplo.com"
                autoComplete="email"
              />
            </label>
            <label className="flex flex-col gap-1">
              <span className="text-sm text-gray-600 dark:text-gray-400">Teléfono (WhatsApp)</span>
              <div className="flex gap-2">
                <select value={countryCode} onChange={e=>setCountryCode(e.target.value)} className="px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900">
                  {COUNTRIES.map(c => <option key={c.code} value={c.code}>{c.code} — {c.name}</option>)}
                </select>
                <input
                  ref={phoneRef}
                  type="tel"
                  value={phone}
                  onInput={()=>{ isTypingRef.current = true; setTimeout(()=>isTypingRef.current=false, 120); }}
                  onChange={e=>{
                    // Sanitiza: solo dígitos, elimina ceros iniciales, limita a 9
                    let digits = (e.target.value || '').replace(/\D/g, '');
                    digits = digits.replace(/^0+/, '');
                    digits = digits.slice(0, 9);
                    setPhone(digits);
                    keepFocus(phoneRef);
                  }}
                  onPaste={(e)=>{
                    e.preventDefault();
                    const text = (e.clipboardData || window.clipboardData).getData('text');
                    let digits = (text || '').replace(/\D/g, '');
                    digits = digits.replace(/^0+/, '');
                    digits = digits.slice(0, 9);
                    setPhone(digits);
                    keepFocus(phoneRef);
                  }}
                  onKeyDown={(e)=>{ if(e.key==='Enter'){ e.preventDefault(); } }}
                  onFocus={()=>{ lastFocusRef.current = phoneRef.current; }}
                  onBlur={(e)=>{
                    const next = e.relatedTarget;
                    const isAllowedNext = next && (next.tagName === 'INPUT' || next.tagName === 'BUTTON' || next.tagName === 'SELECT' || next.getAttribute('role') === 'button');
                    if (!isAllowedNext && isTypingRef.current) {
                      keepFocus(phoneRef);
                    }
                  }}
                  className="flex-1 px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900"
                  placeholder="9 dígitos (sin 0 inicial)"
                  autoComplete="tel"
                  inputMode="tel"
                />
              </div>
            </label>
          </div>
          {!validEmail && email && <div className="text-sm text-red-600 mt-2">Correo inválido</div>}
          {!validPhone && phone && <div className="text-sm text-red-600 mt-1">Ingresa 9 dígitos válidos sin 0 inicial</div>}
        </form>
      )}

      {step === 2 && (
        <div>
          <h1 className="text-xl font-semibold mb-1">Selecciona tu país</h1>
          <p className="text-gray-600 dark:text-gray-300 mb-4">Elige el país principal de tu operación.</p>
          <select value={country2} onChange={e=>setCountry2(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900">
            {COUNTRIES.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
          </select>
        </div>
      )}

      {step === 3 && (
        <div>
          <h1 className="text-xl font-semibold mb-1">Industria</h1>
          <p className="text-gray-600 dark:text-gray-300 mb-4">¿En qué industria estás?</p>
          <select value={industry} onChange={e=>setIndustry(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900">
            <option value="">— Selecciona —</option>
            {INDUSTRIES.map(i => <option key={i} value={i}>{i}</option>)}
          </select>
          {industry === "Otro" && (
            <div className="mt-3">
                  <input value={industryOther} onChange={e=>{ setIndustryOther(e.target.value); }} onFocus={(e)=>{ lastFocusRef.current = e.target; }} className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900" placeholder="¿Cuál es tu industria?" />
            </div>
          )}
        </div>
      )}

      {step === 4 && (
        <div>
          <h1 className="text-xl font-semibold mb-1">¿Cuál es tu inversión promedio mensual en publicidad online?</h1>
          <div className="mt-4 space-y-3">
            {[
              "No invierto en publicidad",
              "Menos de $500 USD",
              "$500 - $2,500 USD",
              "$2,500 USD - $5,000 USD",
              "Más de $5,000 USD",
            ].map(opt => (
              <label key={opt} className="flex items-center gap-3 cursor-pointer">
                <input type="radio" name="adSpend" value={opt} checked={adSpend===opt} onChange={e=>setAdSpend(e.target.value)} />
                <span>{opt}</span>
              </label>
            ))}
          </div>
        </div>
      )}

      {step === 5 && (
        <div>
          <h1 className="text-xl font-semibold mb-1">¿Cuántas personas de tu empresa/negocio usan WhatsApp para atender a clientes?</h1>
          <div className="mt-4 space-y-3">
            {["1 a 2 personas","3 a 5 personas","6 a 10 personas","11 a 25 personas","+25 personas"].map(opt => (
              <label key={opt} className="flex items-center gap-3 cursor-pointer">
                <input type="radio" name="teamSize" value={opt} checked={teamSize===opt} onChange={(e)=>setTeamSize(e.target.value)} />
                <span>{opt}</span>
              </label>
            ))}
          </div>
        </div>
      )}

      {step === 6 && (
        <div>
          <h1 className="text-xl font-semibold mb-1">Tu rol</h1>
          <p className="text-gray-600 dark:text-gray-300 mb-4">Selecciona tu rol.</p>
          <select value={role} onChange={e=>setRole(e.target.value)} className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900">
            <option value="">— Selecciona —</option>
            {roles.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
      )}

      {step === 7 && (
        <div>
          <h1 className="text-xl font-semibold mb-1">Agenda tu demo</h1>
          <p className="text-gray-600 dark:text-gray-300 mb-4">Elige una fecha y hora. Mostramos solo los próximos 2 días y horarios disponibles.</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {twoNextDays.map((d, idx) => {
              const label = d.toLocaleDateString('es-ES', { weekday: 'long', day: '2-digit', month: 'short' });
              const isSel = selectedDayIdx === idx;
              return (
                <button
                  key={idx}
                  type="button"
                  onClick={() => setSelectedDayIdx(idx)}
                  className={`text-left px-4 py-3 rounded-xl border ${isSel ? 'border-indigo-600 bg-indigo-50 dark:bg-indigo-900/20' : 'border-gray-300 dark:border-gray-700'} hover:border-indigo-400`}
                >
                  <div className="font-medium capitalize">{label}</div>
                  <div className="text-xs text-gray-500">Disponibles: 12:00 y 14:00</div>
                </button>
              );
            })}
          </div>

          <div className="mt-5">
            <div className="text-sm text-gray-600 dark:text-gray-300 mb-2">Horarios</div>
            <div className="flex flex-wrap gap-3">
              {["12:00","14:00"].map(t => {
                const on = selectedTime === t;
                return (
                  <button
                    key={t}
                    type="button"
                    disabled={selectedDayIdx === null}
                    onClick={() => setSelectedTime(t)}
                    className={`px-4 py-2 rounded-lg border ${on ? 'border-indigo-600 bg-indigo-50 dark:bg-indigo-900/20' : 'border-gray-300 dark:border-gray-700'} disabled:opacity-50`}
                  >
                    {country2 === 'Ecuador' ? (
                      <div className="flex flex-col items-start">
                        <div>{EC_FLAG} {t}</div>
                      </div>
                    ) : (
                      (() => {
                        try {
                          const [hh, mm] = String(t).split(':');
                          const day = twoNextDays[(selectedDayIdx ?? 0)];
                          const baseDate = buildZonedDate(day.getFullYear(), day.getMonth()+1, day.getDate(), parseInt(hh||'12',10), parseInt(mm||'0',10), 'America/Guayaquil');
                          const meta = COUNTRY_META[country2] || COUNTRY_META['Ecuador'];
                          const alt = formatInZone(baseDate, meta.tz, false, false);
                          return (
                            <div className="flex flex-col items-start">
                              <div>{EC_FLAG} {t}</div>
                              <div className="text-xs text-gray-500">{meta.flag} {alt} {meta.label}</div>
                            </div>
                          );
                        } catch {
                          return t;
                        }
                      })()
                    )}
                  </button>
                );
              })}
            </div>
            {selectedDayIdx === null && <div className="text-xs text-gray-500 mt-2">Primero selecciona un día.</div>}
          </div>
        </div>
      )}

      {step === 8 && (
        <div>
          <h1 className="text-xl font-semibold mb-1">Confirma tus datos</h1>
          <p className="text-gray-600 dark:text-gray-300 mb-4">Revisa el resumen antes de agendar.</p>
          <div className="space-y-2 text-sm">
            <div><span className="font-medium">Nombre:</span> {name}</div>
            <div><span className="font-medium">Correo:</span> {email}</div>
            <div><span className="font-medium">Teléfono:</span> {countryCode} {phone}</div>
            <div><span className="font-medium">País:</span> {country2}</div>
            <div><span className="font-medium">Industria:</span> {industry === 'Otro' ? `${industry} — ${industryOther}` : industry}</div>
            <div><span className="font-medium">Inversión mensual:</span> {adSpend}</div>
            <div><span className="font-medium">Equipo en WhatsApp:</span> {teamSize}</div>
            <div><span className="font-medium">Rol:</span> {role}</div>
            <div>
              <span className="font-medium">Cita:</span>{' '}
              {(() => {
                try {
                  if (selectedDayIdx === null || !selectedTime) return '—';
                  const day = twoNextDays[selectedDayIdx];
                  const [hh, mm] = String(selectedTime).split(':');
                  const baseDate = buildZonedDate(day.getFullYear(), day.getMonth()+1, day.getDate(), parseInt(hh||'12',10), parseInt(mm||'0',10), 'America/Guayaquil');
                  const dayStr = formatInZone(baseDate, 'America/Guayaquil', true, false);
                  const hourEC = formatInZone(baseDate, 'America/Guayaquil', false, false);
                  const meta = COUNTRY_META[country2] || COUNTRY_META['Ecuador'];
                  const hourOther = formatInZone(baseDate, meta.tz, false, false);
                  if (country2 === 'Ecuador') {
                    return `${dayStr} — ${EC_FLAG} ${hourEC} Ecuador - Quito`;
                  }
                  return (
                    <span>
                      {dayStr}
                      <br/>
                      <span>{EC_FLAG} {hourEC} Ecuador - Quito</span>
                      <br/>
                      <span>{meta.flag} {hourOther} {meta.label}</span>
                    </span>
                  );
                } catch { return '—'; }
              })()}
            </div>
          </div>
          <div className="mt-4 text-xs text-gray-500">Si algo está incorrecto, usa “Anterior” para editar.</div>
        </div>
      )}

      {step === 9 && (
        <div>
          <h1 className="text-xl font-semibold mb-1">¡Gracias! Tu demo está casi lista</h1>
          <p className="text-gray-600 dark:text-gray-300 mb-4">Te enviaremos la confirmación al correo y WhatsApp que registraste.</p>
          <div className="bg-gray-50 dark:bg-gray-900/40 border border-gray-200 dark:border-gray-700 rounded-xl p-4">
            <ul className="list-disc ml-5 space-y-2 text-sm">
              <li>Conéctate desde una computadora para aprovechar mejor la demo.</li>
              <li>Ten a mano tus preguntas sobre procesos de WhatsApp y ventas.</li>
              <li>Si necesitas reprogramar, respóndenos por WhatsApp y te ayudamos.</li>
            </ul>
          </div>
          <div className="mt-4 text-sm">
            <span className="font-medium">Cita:</span> {selectedDayIdx !== null ? twoNextDays[selectedDayIdx].toLocaleDateString('es-ES', { weekday:'long', day:'2-digit', month:'long' }) : '—'} a las {selectedTime || '—'}
          </div>
        </div>
      )}
          <div className="mt-6 flex justify-between">
            <button type="button" disabled={step<=1} onClick={()=>setStep(s=>Math.max(1, s-1))} className="px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-700 disabled:opacity-50">Anterior</button>
            <div className="flex items-center gap-3">
              <div className="text-sm text-gray-500">Paso {step} de 9</div>
              {step < 9 ? (
                <button type="button" disabled={!canNext} onClick={()=>setStep(s=>Math.min(9, s+1))} className="px-4 py-2 rounded-lg bg-indigo-600 text-white disabled:opacity-50">Siguiente</button>
              ) : (
                <button type="button" disabled={!canNext || sendingWA} onClick={handleFinalize} className="px-4 py-2 rounded-lg bg-green-600 text-white disabled:opacity-50">{sendingWA? 'Enviando…' : 'Finalizar'}</button>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
